<template>
  <div class="bonus-page">
    <atomic-page-title @on-click="router.back()">
      {{ getContent(pageIdentityContent?.currentLocaleData, pageIdentityContent?.defaultLocaleData, 'title') }}
    </atomic-page-title>

    <div class="bonus-page__header">
      <div class="bonus-page__left">
        <span class="bonus-page__title">
          {{ getContent(pageIdentityContent?.currentLocaleData, pageIdentityContent?.defaultLocaleData, 'subtitle') }}
        </span>
        <span class="bonus-page__subtitle">
          {{ subTitleDescription }}
        </span>
        <button-base
          type="primary"
          size="md"
          @click="
            clickButton(
              getContent(pageIdentityContent?.currentLocaleData, pageIdentityContent?.defaultLocaleData, 'button.url'),
            )
          "
        >
          {{
            getContent(pageIdentityContent?.currentLocaleData, pageIdentityContent?.defaultLocaleData, 'button.label')
          }}

          <template #icon>
            <atomic-icon id="bonuses" />
          </template>
        </button-base>
      </div>
      <div class="bonus-page__right">
        <atomic-picture
          class="bonus-page__img"
          :src="getContent(pageIdentityContent?.currentLocaleData, pageIdentityContent?.defaultLocaleData, 'image')"
          not-lazy
          alt=""
        />
      </div>
    </div>

    <div class="bonus-page__content">
      <atomic-text-editor
        :content="
          getContent(pageIdentityContent?.currentLocaleData, pageIdentityContent?.defaultLocaleData, 'description')
        "
      />
      <div class="bonus-page__detail">
        <div class="bonus-page__detail-title">
          {{ getContent(pageIdentityContent?.currentLocaleData, pageIdentityContent?.defaultLocaleData, 'termsLabel') }}
        </div>
        <atomic-text-editor
          class="bonus-page__detail-description"
          :content="
            getContent(pageIdentityContent?.currentLocaleData, pageIdentityContent?.defaultLocaleData, 'termsContent')
          "
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ModalName } from '@skeleton/consts/modals';
import { replaceProjectName } from '@skeleton/utils/contentReplace';

const route = useRoute();

const rawPageIdentity = route.params.pageIdentity;
const pageIdentity = Array.isArray(rawPageIdentity) ? rawPageIdentity[0] : rawPageIdentity;

const router = useRouter();

const { getContent } = useProjectMethods();
const loadingStore = useLoadingStore();
const profileStore = useProfileStore();
const { isLoggedIn } = storeToRefs(profileStore);
const { openModalSync } = useModalStore();
const { openWalletModal } = useTransactionStore();
const bonusContentStore = useBonusContentStore();
const { loadContent } = bonusContentStore;
const { content: pageIdentityContent, loading } = storeToRefs(bonusContentStore);

await loadContent(pageIdentity);

const clickButton = (url?: string): void => {
  const { handleExternalLink } = useProjectMethods();
  window.scrollTo(0, 0);
  if (url) handleExternalLink(url);
  else if (isLoggedIn.value) openWalletModal('deposit');
  else openModalSync(ModalName.SIGN_IN);
};

const subTitleDescription = computed(() => {
  return replaceProjectName(
    getContent(
      pageIdentityContent.value?.currentLocaleData,
      pageIdentityContent.value?.defaultLocaleData,
      'SubTitleDescription',
    ),
  );
});

watchEffect(() => {
  loadingStore.setLoadingState(loading.value);
});
</script>

<style src="~/assets/styles/pages/bonus/index.scss" lang="scss" />
